import React, { useEffect, useState } from "react";
import { LayoutList } from "lucide-react";
import { api, exportUrl } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { num } from "@/lib/format";
import { Card, Loading, EmptyState, PageHeader } from "@/components/common";

export default function StockDaily() {
  const { branch } = useAuth();
  const [kinds, setKinds] = useState([]);
  const [kind, setKind] = useState("materials");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/reports/stock-daily/kinds").then(setKinds).catch(() => {}); }, []);
  useEffect(() => {
    setLoading(true);
    const p = { kind }; if (branch) p.branch_id = branch.id;
    api.get("/reports/stock-daily", p).then(setData).catch(() => setData(null)).finally(() => setLoading(false));
  }, [kind, branch]);

  return (
    <>
      <PageHeader title="Laporan Stok Harian" subtitle={data?.branch_name || branch?.name} icon={LayoutList}
        actions={
          <div className="flex items-center gap-2">
            <select value={kind} onChange={(e) => setKind(e.target.value)} className="h-10 px-3 rounded-xl border border-slate-300 text-sm" data-testid="stock-kind">
              {kinds.map((k) => <option key={k.key} value={k.key}>{k.label}</option>)}
            </select>
            <a href={exportUrl("stock", { kind, ...(branch ? { branch_id: branch.id } : {}) })} target="_blank" rel="noreferrer" className="text-sm text-primary hover:underline">Ekspor</a>
          </div>
        } />
      {loading ? <Loading /> : !data?.rows?.length ? <EmptyState icon={LayoutList} title="Belum ada data stok" /> : (
        <Card className="overflow-hidden">
          <div className="px-4 py-2 text-xs text-slate-400 border-b border-slate-100">{data.report_no} · {data.date_label}</div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-slate-400 border-b border-slate-100 bg-slate-50/50">
                <th className="py-3 px-4 font-medium">Item</th><th className="py-3 px-4 font-medium text-right">Awal</th>
                <th className="py-3 px-4 font-medium text-right">Masuk</th><th className="py-3 px-4 font-medium text-right">Keluar</th>
                <th className="py-3 px-4 font-medium text-right">Waste</th><th className="py-3 px-4 font-medium text-right">Akhir</th>
              </tr></thead>
              <tbody>
                {data.rows.map((r) => (
                  <tr key={r.item_id || r.no} className="border-b border-slate-50">
                    <td className="py-3 px-4"><div className="font-medium text-slate-800">{r.name}</div>{r.sku && <div className="text-xs text-slate-400">{r.sku}</div>}</td>
                    <td className="py-3 px-4 text-right text-slate-500">{num(r.opening)}</td>
                    <td className="py-3 px-4 text-right text-emerald-600">{num(r.in)}</td>
                    <td className="py-3 px-4 text-right text-slate-600">{num(r.out)}</td>
                    <td className="py-3 px-4 text-right text-rose-600">{num(r.waste)}</td>
                    <td className="py-3 px-4 text-right font-semibold">{num(r.closing)} {r.unit}</td>
                  </tr>
                ))}
                {data.totals && (
                  <tr className="bg-slate-50 font-semibold">
                    <td className="py-3 px-4">TOTAL</td>
                    <td className="py-3 px-4 text-right">{num(data.totals.opening)}</td>
                    <td className="py-3 px-4 text-right">{num(data.totals.in)}</td>
                    <td className="py-3 px-4 text-right">{num(data.totals.out)}</td>
                    <td className="py-3 px-4 text-right">{num(data.totals.waste)}</td>
                    <td className="py-3 px-4 text-right">{num(data.totals.closing)}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </>
  );
}
